"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAwardsApi = exports.AdminAwardsApiFactory = exports.AdminAwardsApiFp = exports.AdminAwardsApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * AdminAwardsApi - axios parameter creator
 * @export
 */
var AdminAwardsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Assign an award winner
         * @param {string} competitionId
         * @param {AssignAwardDto} assignAwardDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerAssignAwardV1: function (competitionId_1, assignAwardDto_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([competitionId_1, assignAwardDto_1], args_1, true), void 0, function (competitionId, assignAwardDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'competitionId' is not null or undefined
                            (0, common_1.assertParamExists)('awardsControllerAssignAwardV1', 'competitionId', competitionId);
                            // verify required parameter 'assignAwardDto' is not null or undefined
                            (0, common_1.assertParamExists)('awardsControllerAssignAwardV1', 'assignAwardDto', assignAwardDto);
                            localVarPath = "/v1/admin/awards/competitions/{competitionId}/assign_tca"
                                .replace("{".concat("competitionId", "}"), encodeURIComponent(String(competitionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(assignAwardDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create award type
         * @param {CreateAwardTypeDto} createAwardTypeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerCreateAwardTypeV1: function (createAwardTypeDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createAwardTypeDto_1], args_1, true), void 0, function (createAwardTypeDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createAwardTypeDto' is not null or undefined
                            (0, common_1.assertParamExists)('awardsControllerCreateAwardTypeV1', 'createAwardTypeDto', createAwardTypeDto);
                            localVarPath = "/v1/admin/awards/types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createAwardTypeDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Deactivate award type
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerDeactivateAwardTypeV1: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('awardsControllerDeactivateAwardTypeV1', 'id', id);
                            localVarPath = "/v1/admin/awards/types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get awards for a competition
         * @param {string} competitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerGetAwardsForCompetitionV1: function (competitionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([competitionId_1], args_1, true), void 0, function (competitionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'competitionId' is not null or undefined
                            (0, common_1.assertParamExists)('awardsControllerGetAwardsForCompetitionV1', 'competitionId', competitionId);
                            localVarPath = "/v1/admin/awards/competitions/{competitionId}"
                                .replace("{".concat("competitionId", "}"), encodeURIComponent(String(competitionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all award types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerListAwardTypesV1: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/admin/awards/types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove TCA award by competition and submission
         * @param {string} competitionId
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerRemoveAwardV1: function (competitionId_1, submissionId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([competitionId_1, submissionId_1], args_1, true), void 0, function (competitionId, submissionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'competitionId' is not null or undefined
                            (0, common_1.assertParamExists)('awardsControllerRemoveAwardV1', 'competitionId', competitionId);
                            // verify required parameter 'submissionId' is not null or undefined
                            (0, common_1.assertParamExists)('awardsControllerRemoveAwardV1', 'submissionId', submissionId);
                            localVarPath = "/v1/admin/awards/competitions/{competitionId}/{submissionId}"
                                .replace("{".concat("competitionId", "}"), encodeURIComponent(String(competitionId)))
                                .replace("{".concat("submissionId", "}"), encodeURIComponent(String(submissionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update award type
         * @param {string} id
         * @param {UpdateAwardTypeDto} updateAwardTypeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerUpdateAwardTypeV1: function (id_1, updateAwardTypeDto_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, updateAwardTypeDto_1], args_1, true), void 0, function (id, updateAwardTypeDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('awardsControllerUpdateAwardTypeV1', 'id', id);
                            // verify required parameter 'updateAwardTypeDto' is not null or undefined
                            (0, common_1.assertParamExists)('awardsControllerUpdateAwardTypeV1', 'updateAwardTypeDto', updateAwardTypeDto);
                            localVarPath = "/v1/admin/awards/types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAwardTypeDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AdminAwardsApiAxiosParamCreator = AdminAwardsApiAxiosParamCreator;
/**
 * AdminAwardsApi - functional programming interface
 * @export
 */
var AdminAwardsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminAwardsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Assign an award winner
         * @param {string} competitionId
         * @param {AssignAwardDto} assignAwardDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerAssignAwardV1: function (competitionId, assignAwardDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.awardsControllerAssignAwardV1(competitionId, assignAwardDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminAwardsApi.awardsControllerAssignAwardV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create award type
         * @param {CreateAwardTypeDto} createAwardTypeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerCreateAwardTypeV1: function (createAwardTypeDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.awardsControllerCreateAwardTypeV1(createAwardTypeDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminAwardsApi.awardsControllerCreateAwardTypeV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Deactivate award type
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerDeactivateAwardTypeV1: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.awardsControllerDeactivateAwardTypeV1(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminAwardsApi.awardsControllerDeactivateAwardTypeV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get awards for a competition
         * @param {string} competitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerGetAwardsForCompetitionV1: function (competitionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.awardsControllerGetAwardsForCompetitionV1(competitionId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminAwardsApi.awardsControllerGetAwardsForCompetitionV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all award types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerListAwardTypesV1: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.awardsControllerListAwardTypesV1(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminAwardsApi.awardsControllerListAwardTypesV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove TCA award by competition and submission
         * @param {string} competitionId
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerRemoveAwardV1: function (competitionId, submissionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.awardsControllerRemoveAwardV1(competitionId, submissionId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminAwardsApi.awardsControllerRemoveAwardV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update award type
         * @param {string} id
         * @param {UpdateAwardTypeDto} updateAwardTypeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerUpdateAwardTypeV1: function (id, updateAwardTypeDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.awardsControllerUpdateAwardTypeV1(id, updateAwardTypeDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminAwardsApi.awardsControllerUpdateAwardTypeV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AdminAwardsApiFp = AdminAwardsApiFp;
/**
 * AdminAwardsApi - factory interface
 * @export
 */
var AdminAwardsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminAwardsApiFp)(configuration);
    return {
        /**
         *
         * @summary Assign an award winner
         * @param {string} competitionId
         * @param {AssignAwardDto} assignAwardDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerAssignAwardV1: function (competitionId, assignAwardDto, options) {
            return localVarFp.awardsControllerAssignAwardV1(competitionId, assignAwardDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create award type
         * @param {CreateAwardTypeDto} createAwardTypeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerCreateAwardTypeV1: function (createAwardTypeDto, options) {
            return localVarFp.awardsControllerCreateAwardTypeV1(createAwardTypeDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deactivate award type
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerDeactivateAwardTypeV1: function (id, options) {
            return localVarFp.awardsControllerDeactivateAwardTypeV1(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get awards for a competition
         * @param {string} competitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerGetAwardsForCompetitionV1: function (competitionId, options) {
            return localVarFp.awardsControllerGetAwardsForCompetitionV1(competitionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all award types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerListAwardTypesV1: function (options) {
            return localVarFp.awardsControllerListAwardTypesV1(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove TCA award by competition and submission
         * @param {string} competitionId
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerRemoveAwardV1: function (competitionId, submissionId, options) {
            return localVarFp.awardsControllerRemoveAwardV1(competitionId, submissionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update award type
         * @param {string} id
         * @param {UpdateAwardTypeDto} updateAwardTypeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardsControllerUpdateAwardTypeV1: function (id, updateAwardTypeDto, options) {
            return localVarFp.awardsControllerUpdateAwardTypeV1(id, updateAwardTypeDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminAwardsApiFactory = AdminAwardsApiFactory;
/**
 * AdminAwardsApi - object-oriented interface
 * @export
 * @class AdminAwardsApi
 * @extends {BaseAPI}
 */
var AdminAwardsApi = /** @class */ (function (_super) {
    __extends(AdminAwardsApi, _super);
    function AdminAwardsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Assign an award winner
     * @param {string} competitionId
     * @param {AssignAwardDto} assignAwardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAwardsApi
     */
    AdminAwardsApi.prototype.awardsControllerAssignAwardV1 = function (competitionId, assignAwardDto, options) {
        var _this = this;
        return (0, exports.AdminAwardsApiFp)(this.configuration).awardsControllerAssignAwardV1(competitionId, assignAwardDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create award type
     * @param {CreateAwardTypeDto} createAwardTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAwardsApi
     */
    AdminAwardsApi.prototype.awardsControllerCreateAwardTypeV1 = function (createAwardTypeDto, options) {
        var _this = this;
        return (0, exports.AdminAwardsApiFp)(this.configuration).awardsControllerCreateAwardTypeV1(createAwardTypeDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deactivate award type
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAwardsApi
     */
    AdminAwardsApi.prototype.awardsControllerDeactivateAwardTypeV1 = function (id, options) {
        var _this = this;
        return (0, exports.AdminAwardsApiFp)(this.configuration).awardsControllerDeactivateAwardTypeV1(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get awards for a competition
     * @param {string} competitionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAwardsApi
     */
    AdminAwardsApi.prototype.awardsControllerGetAwardsForCompetitionV1 = function (competitionId, options) {
        var _this = this;
        return (0, exports.AdminAwardsApiFp)(this.configuration).awardsControllerGetAwardsForCompetitionV1(competitionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all award types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAwardsApi
     */
    AdminAwardsApi.prototype.awardsControllerListAwardTypesV1 = function (options) {
        var _this = this;
        return (0, exports.AdminAwardsApiFp)(this.configuration).awardsControllerListAwardTypesV1(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove TCA award by competition and submission
     * @param {string} competitionId
     * @param {string} submissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAwardsApi
     */
    AdminAwardsApi.prototype.awardsControllerRemoveAwardV1 = function (competitionId, submissionId, options) {
        var _this = this;
        return (0, exports.AdminAwardsApiFp)(this.configuration).awardsControllerRemoveAwardV1(competitionId, submissionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update award type
     * @param {string} id
     * @param {UpdateAwardTypeDto} updateAwardTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAwardsApi
     */
    AdminAwardsApi.prototype.awardsControllerUpdateAwardTypeV1 = function (id, updateAwardTypeDto, options) {
        var _this = this;
        return (0, exports.AdminAwardsApiFp)(this.configuration).awardsControllerUpdateAwardTypeV1(id, updateAwardTypeDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminAwardsApi;
}(base_1.BaseAPI));
exports.AdminAwardsApi = AdminAwardsApi;
